import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useState } from "react";
import { CookieConsent } from "@/components/CookieConsent";
import AnimatedRoutes from "@/components/AnimatedRoutes";
import ScrollManager from "@/components/ScrollManager";
import ScrollWatchdog from "@/components/ScrollWatchdog";

const App = () => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <HelmetProvider>
      <CookieConsent>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <Toaster />
            <BrowserRouter>
              <ScrollManager />
              <ScrollWatchdog />
              <AnimatedRoutes />
            </BrowserRouter>
          </TooltipProvider>
        </QueryClientProvider>
      </CookieConsent>
    </HelmetProvider>
  );
};

export default App;
